module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r3n4r8n-e265fe8ff47406ce09c4b228147c7049.svg";